
import { useRef } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import Navbar from '@/components/layout/Navbar';
import { PlaylistProvider } from '@/contexts/PlaylistContext';
import { useCreators } from '@/hooks/useCreators';
import NoSubscriptionsMessage from '@/components/feed/NoSubscriptionsMessage';
import LoadingFeed from '@/components/feed/LoadingFeed';
import EndOfFeed from '@/components/feed/EndOfFeed';
import RefreshButton from '@/components/feed/RefreshButton';
import LoadMoreButton from '@/components/feed/LoadMoreButton';
import EmptyFeed from '@/components/feed/EmptyFeed';
import FeedHeader from '@/components/feed/FeedHeader';
import { usePerformantFeed } from '@/hooks/usePerformantFeed';
import RSSIndicator from '@/components/feed/RSSIndicator';
import CacheIndicator from '@/components/feed/CacheIndicator';
import VideoGroup from '@/components/feed/VideoGroup';

const FeedContent = () => {
  const { subscribedCreators } = useCreators();
  const feedContainerRef = useRef<HTMLDivElement>(null);
  const isMobile = useIsMobile();
  
  const {
    videosByDate,
    loading,
    loadingMore,
    refreshing,
    error,
    formatDateHeader,
    handleRefresh,
    loadMoreWeeks,
    hasMoreWeeks,
    newVideosCount,
    usingCache,
    usingRSS
  } = usePerformantFeed();

  console.log('Feed - RSS active:', usingRSS);
  console.log('Feed - Cache active:', usingCache);
  console.log('Feed - New videos count:', newVideosCount);
  console.log('Feed - Videos count:', videosByDate.length);
  console.log('Feed - Subscribed creators:', subscribedCreators.length);

  return (
    <div className="min-h-screen bg-youtube-light dark:bg-youtube-dark">
      <Navbar />
      
      <div 
        className={`h-[calc(100vh-64px)] overflow-auto scrollbar-hide ${isMobile ? 'pb-24' : ''}`}
        ref={feedContainerRef}
      >
        <main className="page-container">
          <FeedHeader 
            onRefresh={handleRefresh}
            isRefreshing={refreshing}
            isLoading={loading}
          />
          
          <RSSIndicator isUsingRSS={usingRSS} />
          <CacheIndicator isUsingCache={usingCache} newVideosCount={newVideosCount} />
          
          {subscribedCreators.length === 0 ? (
            <NoSubscriptionsMessage />
          ) : (loading && videosByDate.length === 0) ? (
            <LoadingFeed />
          ) : videosByDate.length > 0 ? (
            <div className="space-y-8 animate-fade-in">
              {videosByDate.map(({ date, videos }) => (
                <VideoGroup 
                  key={date}
                  date={date}
                  videos={videos}
                  formatDateHeader={formatDateHeader}
                />
              ))}

              <LoadMoreButton 
                onLoadMore={loadMoreWeeks}
                loading={loadingMore}
                hasMore={hasMoreWeeks}
              />
            </div>
          ) : (
            <EmptyFeed 
              message="Aucune vidéo disponible"
              subMessage={usingCache ? 
                "Chargement depuis le cache - Actualisation en cours en arrière-plan." :
                usingRSS ? 
                "Mode RSS actif - Dernières vidéos chargées via les flux RSS." :
                "Il n'y a pas de vidéos des créateurs auxquels vous êtes abonné. Revenez plus tard ou abonnez-vous à d'autres créateurs."
              }
            />
          )}
        </main>
      </div>
    </div>
  );
};

const Feed = () => {
  return (
    <PlaylistProvider>
      <FeedContent />
    </PlaylistProvider>
  );
};

export default Feed;
